module.exports = __webpack_public_path__ + "img/36312E_726461_59504D_645C5C-256px.793e5c70.png";